export const ServiceTag = ({ number, label, dark = false }) => (
  <p className="flex items-center gap-4" data-testid={`service-tag-${number}`}>
    <span className="font-display text-2xl font-extrabold text-[#ff6a00]">{number}</span>
    <span className="block h-px w-8 bg-[#ff6a00]" aria-hidden="true" />
    <span className={`text-xs font-bold uppercase tracking-[0.22em] ${dark ? "text-white/60" : "text-[#5f666d]"}`}>
      {label}
    </span>
  </p>
);

export const CapList = ({ items, dark = false, testid }) => (
  <ul className="grid gap-x-6 gap-y-3 sm:grid-cols-2" data-testid={testid}>
    {items.map((item) => (
      <li key={item} className="flex items-center gap-3">
        <span className="block h-1.5 w-1.5 shrink-0 bg-[#ff6a00]" aria-hidden="true" />
        <span className={`text-[13px] font-bold tracking-[0.1em] ${dark ? "text-white/85" : "text-[#191c1e]"}`}>
          {item}
        </span>
      </li>
    ))}
  </ul>
);

export const ImageFrame = ({ src, alt, caption, testid, className = "aspect-[4/3]", dark = false, natural = false }) => (
  <figure
    className={`relative border ${dark ? "border-[#2b2f33]" : "border-[#e5e7eb]"} ${natural ? "" : className}`}
    data-testid={`${testid}-frame`}
  >
    <img
      src={src}
      alt={alt}
      data-testid={testid}
      className={natural ? "h-auto w-full" : "absolute inset-0 h-full w-full object-cover"}
      loading="lazy"
    />
    {caption && (
      <figcaption className="absolute bottom-0 left-0 max-w-full bg-[#191c1e] px-4 py-2 text-[10px] font-bold leading-relaxed tracking-[0.14em] text-white sm:text-[11px] sm:tracking-[0.16em]">
        {caption}
      </figcaption>
    )}
  </figure>
);
